import Immutable from 'immutable';
import * as ActionTypes from '../../actionTypes/cruiseListActionTypes';

const initialState = Immutable.fromJS({
  initialized: false,
  cruises: [],
  searchInformation: {},
});

export default (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.INIT_FINISHED:
      return state.withMutations((s) => {
        s.set('initialized', true);
      });
    case ActionTypes.INIT_SUCCESS:
      return state.withMutations((s) => {
        s.set('cruises', action.cruises);
        s.set('searchInformation', action.searchInformation);
      });
    default:
      return state;
  }
};
